import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStore = defineStore('loading', () => {
  const isOverlay = ref(false)
  const isLoading = ref(false)
  const loadingMessage = ref('');
  const loginMode = ref('none');

  const showOverlay = () => {
    isOverlay.value = true
    document.body.classList.add('on');
  }

  const hideOverlay = () => {
    isOverlay.value = false
    document.body.classList.remove('on');
  }

  const showLoading = (message) => {
    loadingMessage.value = message;
    isLoading.value = true
  }

  const hideLoading = (time = 0) => {
    setTimeout(() => {
      isLoading.value = false;
      loadingMessage.value = '';
    }, time);
  }

  const setLoginMode = (mode) => {
    loginMode.value = mode;
  };


  return {
    isOverlay,
    isLoading,
    loginMode,
    loadingMessage,
    showOverlay,
    hideOverlay,
    showLoading,
    hideLoading,
    setLoginMode,
  }
});
